import type { PipelineNodeStatus } from "../../types";

export const STATUS_COLORS: Record<
  PipelineNodeStatus,
  { border: string; bg: string; text: string; icon: string }
> = {
  planned: {
    border: "border-gray-600",
    bg: "bg-gray-300/85",
    text: "text-gray-800",
    icon: "text-gray-700",
  },
  pending: {
    border: "border-amber-200",
    bg: "bg-amber-50",
    text: "text-amber-700",
    icon: "text-amber-500",
  },
  active: {
    border: "border-blue-400",
    bg: "bg-blue-50",
    text: "text-blue-700",
    icon: "text-blue-500",
  },
  completed: {
    border: "border-emerald-500",
    bg: "bg-emerald-100/80",
    text: "text-emerald-800",
    icon: "text-emerald-600",
  },
  failed: {
    border: "border-red-400",
    bg: "bg-red-50",
    text: "text-red-700",
    icon: "text-red-500",
  },
  aborted: {
    border: "border-orange-300",
    bg: "bg-orange-50",
    text: "text-orange-700",
    icon: "text-orange-500",
  },
  blocked: {
    border: "border-slate-300",
    bg: "bg-slate-100",
    text: "text-slate-700",
    icon: "text-slate-500",
  },
  // **「実行対象外」は「未実行」と見分けられなければならない。**
  // 灰色だと planned と同じに見え、止まっているのか対象外なのか
  // 判別できない（外部案件の連絡履歴要約がまさにそれだった）。
  // 完了と同じ緑系の薄い色にして「もう待たなくてよい」を示す。
  skipped: {
    border: "border-emerald-300",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    icon: "text-emerald-500",
  },
};
